import React from 'react';
import { Helmet } from 'react-helmet';
import { PageHeader } from '../../components/PageHeader'
import { getUIString } from '../../utils/helpers';
import { CustomerServiceSection } from './CustomerServiceSection'
import { OfferingType } from '../../utils/offeringType';

interface Props {
	accountType: string;
	offeringType: OfferingType;
}

export const CustomerServicePage: React.FC<Props> = (props: Props) => {
	return (
		<article>
			<Helmet
				title="Asiakaspalvelu"
				meta={[
					{ name: 'description', content: 'Asiakaspalvelu' },
				]}
			/>
			<PageHeader>{getUIString(props.accountType, 'CustomerServicePage.header')}</PageHeader>
			<CustomerServiceSection icon="medium--search" href={getUIString(props.accountType, 'CustomerServicePage.link')} >
				Usein kysyttyä
			</CustomerServiceSection>
			<CustomerServiceSection icon="medium--customer-service" href={`tel: ${getUIString(props.accountType, 'CustomerServicePage.phone')}`} newWindow={false}>
				Ota yhteyttä asiakaspalveluun<br />
				Auki arkisin klo 8-18<br />
				{getUIString(props.accountType, 'CustomerServicePage.phone')} (mpm/pvm)<br />
				{getUIString(props.accountType, 'CustomerServicePage.email')}  {/* TODO: href tel is over this. This should be in separate section? */}
			</CustomerServiceSection>
			<CustomerServiceSection icon="medium--facebook" href="https://www.facebook.com/moimobiili">
				Tykkää meistä
			</CustomerServiceSection>
			<CustomerServiceSection icon="medium--twitter" href="https://twitter.com/moimobiili">
				Seuraa meitä
			</CustomerServiceSection>
		</article>
	);
}
